import React, { useState, useEffect } from 'react';
import MoodSelector from './MoodSelector';
import MoodHistory from './MoodHistory';
import { storage } from '../../utils/storage';
import { MOOD_CONTEXTS } from '../../utils/constants';
import { useTheme } from '../../hooks/useTheme';

const MoodTracking = () => {
  const [moodData, setMoodData] = useState([]);
  const [selectedMood, setSelectedMood] = useState(0);
  const [selectedContexts, setSelectedContexts] = useState([]);
  const [note, setNote] = useState('');
  const { theme } = useTheme();

  useEffect(() => {
    const saved = storage.get('moodData') || [];
    setMoodData(saved);
  }, []);

  const handleSubmit = () => {
    if (selectedMood > 0) {
      const newEntry = {
        id: Date.now(),
        date: new Date().toISOString(),
        mood: selectedMood,
        contexts: selectedContexts,
        note: note
      };
      
      const updated = [...moodData, newEntry];
      setMoodData(updated);
      storage.set('moodData', updated);
      
      // Reset form
      setSelectedMood(0);
      setSelectedContexts([]);
      setNote('');
      
      alert('Mood entry saved successfully!');
    }
  };

  const toggleContext = (contextId) => {
    setSelectedContexts(prev => 
      prev.includes(contextId) 
        ? prev.filter(c => c !== contextId)
        : [...prev, contextId]
    );
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold mb-2">Mood Check-In</h1>
        <p className="text-gray-600">How are you feeling today?</p>
      </div>

      <MoodSelector selectedMood={selectedMood} onMoodSelect={setSelectedMood} />

      {/* Context Selection */}
      <div className={`p-6 rounded-xl ${theme === 'dark' ? 'bg-gray-800' : 'bg-white'} shadow-lg`}>
        <h3 className="font-semibold mb-4">What's influencing your mood?</h3>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          {MOOD_CONTEXTS.map(context => (
            <button
              key={context.id}
              onClick={() => toggleContext(context.id)}
              className={`p-3 rounded-lg flex items-center space-x-2 transition-all ${
                selectedContexts.includes(context.id)
                  ? 'bg-blue-100 border-2 border-blue-500'
                  : theme === 'dark' ? 'bg-gray-700 hover:bg-gray-600' : 'bg-gray-100 hover:bg-gray-200'
              }`}
            >
              <span className="text-xl">{context.icon}</span>
              <span className="font-medium">{context.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Notes */}
      <div className={`p-6 rounded-xl ${theme === 'dark' ? 'bg-gray-800' : 'bg-white'} shadow-lg`}>
        <h3 className="font-semibold mb-4">Add a note (optional)</h3>
        <textarea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="What's on your mind?"
          className={`w-full p-3 rounded-lg border ${
            theme === 'dark' 
              ? 'bg-gray-700 border-gray-600' 
              : 'bg-gray-50 border-gray-300'
          } focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
          rows={4}
        />
      </div>

      {/* Submit Button */}
      <button
        onClick={handleSubmit}
        disabled={selectedMood === 0}
        className={`w-full py-3 rounded-lg font-medium transition-colors ${
          selectedMood > 0
            ? 'bg-blue-600 text-white hover:bg-blue-700'
            : 'bg-gray-300 text-gray-500 cursor-not-allowed'
        }`}
      >
        Save Entry
      </button>

      <MoodHistory moodData={moodData} />
    </div>
  );
};

export default MoodTracking;